// src/utils/searchUtils.js

/**
 * Calculates a match score for a single string.
 */
const getScore = (text, term) => {
  if (!text) return 0;
  const lowerText = text.toLowerCase();
  
  if (lowerText === term) return 100;       // Exact match
  if (lowerText.startsWith(term)) return 50; // Starts with
  if (lowerText.includes(term)) return 10;   // Contains
  return 0;
};

/**
 * Sorts documents based on matching individual topics inside their topic_list array.
 * * @param {Array} documents - List of topic documents from DB
 * @param {string} searchTerm - User input
 * @returns {Array} - Filtered and Sorted list
 */
export const searchTopicsArray = (documents, searchTerm) => {
  if (!searchTerm || !searchTerm.trim()) {
    return documents;
  }

  const term = searchTerm.toLowerCase().trim();

  return documents
    .map((doc) => {
      // 1. Get the list of topics (e.g., ["Algebra", "Geometry"])
      const topics = doc.topic_list || [];
      
      // 2. Find the highest score among ALL topics in this document
      // If "Algebra" scores 0 but "Geometry" scores 50, the document score is 50.
      let maxDocScore = 0;

      topics.forEach((topicStr) => {
        const score = getScore(topicStr, term);
        if (score > maxDocScore) {
          maxDocScore = score;
        }
      });

      return { ...doc, score: maxDocScore };
    })
    .filter((doc) => doc.score > 0)        // Keep only matches
    .sort((a, b) => b.score - a.score);    // Sort highest score first
};
